"use client";
import Typography from '@mui/material/Typography';
import type { FC } from 'react';
import { highlightSx } from '~/app/versuri/VersuriSearchStyleHighlight';
import { highlightText } from '~/lib/lyrics.shared';

interface VersuriHighlightProps {
  snippet?: string | null;
  decodedQuery: string;
  linesToPreview?: number;
}

const VersuriHighlight: FC<VersuriHighlightProps> = ({ snippet, decodedQuery, linesToPreview }) => {
  if (!snippet) return null;

  const hasServerHighlight = /<\s*strong\b/i.test(snippet);
  const html = hasServerHighlight ? snippet : highlightText(snippet, decodedQuery);

  return (
    <Typography
      variant="body2"
      dangerouslySetInnerHTML={{ __html: html }}
      sx={{
        color: 'text.secondary',
        zIndex: 0,
        display: '-webkit-box',
        WebkitLineClamp: linesToPreview || 3,
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',

        ...highlightSx,
      }}
    />
  );
};

export default VersuriHighlight;
